import styled, { css } from 'styled-components'

export const HiddenDisplayNoneStyled = styled.div<{ isHide?: boolean }>`
	${({ isHide = true }) =>
		isHide &&
		css`
			display: none;
		`}
`
